import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { entityLikeSchemaUuidStrict } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { BudgetRevenueAdminFindInterface } from '@zaoblako/shared/modules/catalog/dtos/budget-revenue-admin/budget-revenue-admin-find.dto';

import * as yup from 'yup';

/** Budget classification code create and update APIs request body - DTO signature */
export interface BudgetClassificationCodeFormInterface {
  /** Budget classification code unique code (20 digits) */
  code: string;
  /** Budget classification code display name */
  name: string;
  /** Budget revenue admin this budget classification code belongs to */
  budgetRevenueAdmin: BudgetRevenueAdminFindInterface;
}

/** Budget classification code create and update APIs request body - DTO schema */
export const BudgetClassificationCodeFormDto = SerdeDtoClass.create<BudgetClassificationCodeFormInterface>(
  CatalogDtosKeysEnum.BUDGET_CLASSIFICATION_CODE_FORM_DTO,
  {
    code: {
      label: 'Код',
      serializer: yup
        .string()
        .matches(/^\d{20}$/im, 'Код должен состоять из 20 цифр'),
    },
    name: {
      label: 'Название',
      serializer: nonEmptyStringSchema,
    },
    budgetRevenueAdmin: {
      label: 'Администратор платежа',
      serializer: entityLikeSchemaUuidStrict,
      checkers: [CatalogCheckersEnum.BUDGET_REVENUE_ADMIN_ASSERT_EXISTS_BY_DTO],
    },
  },
);
